import Vue from "vue";
import VueFbCustomerChat from "vue-fb-customer-chat";

Vue.use(VueFbCustomerChat, {
  page_id: 301933830065, //  change 'null' to your Facebook Page ID,
  theme_color: "#EF3E2D", // theme color in HEX
  locale: "en_US", // default 'en_US'
});

export default {};
